import cn from 'classnames';
/* Class assignment */
export var recordaudiobuttonClass = function (className) { return cn(className, 'w-8'); };
